import React from 'react';
import useAuthStore from '../store/authStore';
import AdminDashboard from './admin/AdminDashboard';
import ParentDashboard from './parent/ParentDashboard';
import Dashboard from './Dashboard';

/**
 * /dashboard renders different content per role: dedicated dashboards for
 * administrator and parent, and the existing shared dashboard for
 * teacher/student (which already branches its stats on isTeacher).
 */
export default function RoleDashboard() {
  const { user } = useAuthStore();
  const roles = (user?.roles || []).map((r) => r.name?.toLowerCase());

  if (user?.is_platform_owner || roles.includes('administrator')) return <AdminDashboard />;
  if (roles.includes('parent')) return <ParentDashboard />;
  return <Dashboard />;
}
